
import environment from "environment";
import qs from "qs";
import { requestService } from "./request";
import type { ModuleNames } from "../actions/accountModules";

const getAccountModules = (modules: Array<ModuleNames>): Promise<any> => requestService
  .get(environment.endpoints.get.accountModules, {
    params: { modules },
    paramsSerializer: (params: any) =>
      qs.stringify(params, { arrayFormat: "brackets", encode: false }),
  });

export default getAccountModules;
